import { GetB2bOrderDetailsResponse } from '@Common/types/b2b/orders';
import { OrderInitiator } from '@Common/types/bo/orders/common';

import { ordersTranslations as ordersTranslationsEn } from '@I18n/en/orders';

export const ordersTranslations = {
  fields: {
    id: 'ID Ordre',
    employee_id: 'ID Adhérent',
    instrument_id: 'ID Instrument',
    company_id: 'ID Entreprise',
    user_id: 'ID Utilisateur',
    b2b_individual_operation_id: 'ID Opération individuelle',
    side: 'Sens',
    quantity: 'Quantité',
    short_name: 'Libellé fonds',
    isin: 'ISIN',
    operation: 'Opération',
    user_currency: 'Devise utilisateur',
    status: 'Statut',
    user_currency_amount: 'Montant éxécuté',
    user_currency_amount_input: 'Montant',
    net_amount: 'Montant net',
    total_gross_amount: 'Montant brut',
    filled_quantity: 'Quantité éxécutée',
    b2b_company_plan_id: 'ID Plan',
    od_orders_aggregated_id: 'ID Ordre aggrégé',
    recurring_fee_charge_id: 'ID charge frais récurrent',
    b2b_recurring_investment_id: 'B2B Investissement Récurrent ID',
    contract_id: 'ID Contrat',
    created_at: 'Créé à',
    updated_at: 'Mis à jour à',
    linked_transfer_id: 'ID transfer lié',
    files: 'Fichiers',
    is_matching_contribution: 'Abondement?',
    matching_contribution_pool_year: "Année du pool d'abondement",
    tax_amount: 'Montant taxe',
    tax_info: 'Information taxe',
    fee_amount: 'Montant total des frais',
    entry_fee_amount: "Frais d'entrée",
    entry_fee_company_amount: 'Frais d’entrée entreprise',
    entry_fee_employee_amount: 'Frais d’entrée salarié',
    entry_fee_rate: "Taux d'entrée",
    shares_fee_amount: 'Frais pris par Shares',
    fee_info: 'Information sur les frais',
    matched_contribution_order_id: 'ID ordre lié',
    matching_contribution_order_id: 'ID Ordre abondement',
    savings_funds_requests_id: 'ID Appel de fonds',
    filled_avg_price: "Prix moyen d'éxécution",
    instrument_currency: 'Devise',
    campaign_id: 'ID Opération',
    oddo_status: 'Statut Oddo',
    correlation_id: 'ID Correlation',
    initiator: 'Initiateur',
    reference_uuid: 'Référence UUID',
    b2b_withdrawal_id: 'ID Retrait',
    trade_confirmation_document_id: 'Trade Confirmation',
    arbitrage_sell_order_id: "ID ordre de vente d'arbitrage",
    b2b_transfer_request_id: 'Transfer Request ID',
    passive_price_reference_at: 'Déclenchement du calcul de la VL d’exécution à',
    passive_nav_date_at: 'VL d’exécution à',
    rejected_code: 'Code de rejet',
    rejected_description: 'Description de rejet',
    passive_nav_source: 'Source de la VL',
    filled_at: 'Exécuté à',
    corrected_od_order_id: 'ID Ordre corrigé',
    cancellation_reason: "Raison d'annulation",
    cancellation_initiator: "Initiateur d'annulation",
    canceled_at: 'Annulé à',
    internal_note: 'Note interne',
  } satisfies Record<
    keyof Omit<
      GetB2bOrderDetailsResponse,
      | 'is_cancelable'
      | 'qty_decimal_places'
      | 'correction_orders'
      | 'ledger_corrections'
      | 'effective_state'
      | 'passive_nav_calculation'
    >,
    string
  >,
  sections: {
    details: 'Détails',
    execution: 'Éxécution',
    matching_contribution: 'Abondement',
    other: 'Autre',
  },
  choices: {
    initiator: {
      shares: 'Shares',
      user: 'Utilisateur',
      broker: 'Courtier',
      bo: 'Utilisateur back-office',
    } satisfies Record<OrderInitiator, string>,
  },
} satisfies typeof ordersTranslationsEn;
